// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Style_overlay__2NFyx","logoContainer":"Style_logoContainer__2_FGU","logo":"Style_logo__ceN9a"};